var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxtFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 4.5V8h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v6H2V2a2 2 0 0 1 2-2h5.5L14 4.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.074 10.007H13.97V15.4h-1.322v-5.393H10.57V9h5.503v1.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.084 11.294 9.298 9h1.547l-1.922 3.174 1.969 3.226H9.354l-1.251-2.33-1.247 2.33H5.3l1.968-3.226L5.351 9H6.89l1.195 2.294Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.503 10.007H3.398V15.4H2.077v-5.393H0V9h5.503v1.007Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtFile);
export default __webpack_public_path__ + "static/media/txt-file.a76cc1ec0de91698fbf85ba4285fc364.svg";
export { ForwardRef as ReactComponent };